export const createTag = (tag, payload) => {
  return new Promise((resolve, reject) => {
    const element = document.createElement(tag);
    const firstTagOfType = document.getElementsByTagName(tag)[0];
    if (!firstTagOfType) return;

    Object.assign(element, {
      onload: () => resolve(),
      onerror: err => reject(err),
      ...payload
    });
    firstTagOfType.parentNode.insertBefore(element, firstTagOfType);
  });
};
